

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.DjDyIeO9.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/IHki7fMi.js","_app/immutable/chunks/CUEW_ppn.js","_app/immutable/chunks/BwpWoHbM.js","_app/immutable/chunks/DC8ybcx3.js"];
export const stylesheets = [];
export const fonts = [];
